import { render, staticRenderFns } from "./Connections.vue?vue&type=template&id=a8eba622&scoped=true&lang=pug&"
import script from "./Connections.vue?vue&type=script&lang=js&"
export * from "./Connections.vue?vue&type=script&lang=js&"
import style0 from "./Connections.vue?vue&type=style&index=0&id=a8eba622&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8eba622",
  null
  
)

/* custom blocks */
import block0 from "./Connections.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports